module.exports = __webpack_public_path__ + "static/media/gplay.f06b9089.png";